import { EMPTY_STRING } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';
import { SettingsAddressFormType, settingsAddressValidation, useWithAddressVerify } from '@uplift/ui-v2';
import { useSaveProfile } from '../../hooks';
import { useUpdateSettings } from '../../hooks/use-update-settings.hook';
import { useUserProfileQuery } from '@uplift/queries';
import { useCurrentuser } from '@uplift/contexts';

export type AddressFormType = SettingsAddressFormType;

export const useAddressForm = () => {
  const l10n = useL10n();
  const me = useCurrentuser();
  const { onFormSubmitSuccess, onFormSubmitError } = useUpdateSettings();
  const { data: profile } = useUserProfileQuery(me.id, { suspense: true });
  const saveProfile = useSaveProfile();
  const withAddressVerify = useWithAddressVerify();

  const addressFormik = () => {
    const initialValues: AddressFormType = {
      address1: profile.address?.line1 ?? EMPTY_STRING,
      address2: profile?.address.line2 ?? EMPTY_STRING,
      city: profile?.address.city ?? EMPTY_STRING,
      state: profile?.address.stateId ?? EMPTY_STRING,
      zip: profile?.address.zip ?? EMPTY_STRING,
    };

    const validationSchema = settingsAddressValidation(l10n);

    const onSubmit = withAddressVerify(async (values: AddressFormType) => {
      try {
        await saveProfile({
          address: {
            line1: values.address1,
            line2: values.address2,
            city: values.city,
            stateId: values.state,
            zip: values.zip
          }
        });

        onFormSubmitSuccess();
      } catch (error) {
        onFormSubmitError();
      }
    }, {
      shouldCheck: true,
      initialAddress: initialValues
    });

    return { initialValues, validationSchema, onSubmit };
  };

  return { addressFormik };
};
